import { BlogHomeRecord } from '../../../../types/dato';
import { LocaleAllow, MetaProps } from '../../../../types/IHeader';
import { getBlogBreadcrumbs } from '../../../utils/breadcrumbs';
import { BreadcrumbList, ListItem } from 'schema-dts';
import { siteUrl } from '..';

export const breadcrumb = (
  data: MetaProps,
  uri: string,
  locale: LocaleAllow,
  localeSlug: string,
  dataWithBreadcrumb?: BlogHomeRecord | null,
): BreadcrumbList => {
  let breadcrumps: ListItem[] = [];
  let slugBlog = '';
  const title =
    data?.metaFields?.title ||
    data?.content?.[0]?.title ||
    data?.hero?.[0]?.title;

  if (!!dataWithBreadcrumb && !!data?.subCategory) {
    const dataBreadcrumps = getBlogBreadcrumbs(
      data,
      dataWithBreadcrumb,
      locale,
    );

    const newBreadcrumps = dataBreadcrumps?.items?.reduce(function (
      filtered: ListItem[],
      item,
      index,
    ) {
      if (item?.node && typeof item.node === 'object' && 'props' in item.node) {
        if (index === 0) {
          slugBlog = item?.node?.props?.url;
        }
        filtered?.push({
          '@type': 'ListItem',
          position: index + 2,
          name: item?.node?.props?.title,
          item: `${siteUrl}${item?.node?.props?.url}`,
        });
      }
      return filtered;
    }, []);
    if (newBreadcrumps?.length > 0) {
      breadcrumps = [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: `${siteUrl}/${localeSlug}`,
        },
        ...newBreadcrumps,
      ];
    }
  } else if (data) {
    breadcrumps = [
      {
        '@type': 'ListItem',
        position: 1,
        name: data?.slug !== 'home' ? 'Home' : title,
        item: `${siteUrl}/${localeSlug}`,
      },
    ];

    const slugParentSplit = uri?.slice(1, -1)?.split('/');
    const maxLength = locale !== 'en' ? 2 : 1;
    if (slugParentSplit?.length > maxLength) {
      slugBlog = `${localeSlug}${slugParentSplit[slugParentSplit.length - 2]}/`;
      breadcrumps.push({
        '@type': 'ListItem',
        position: 2,
        name: `${slugParentSplit[slugParentSplit?.length - 2].replace(
          /-/g,
          ' ',
        )}`,
        item: `${siteUrl}/${slugBlog}`,
      });
    }
    if (data?.slug !== 'home') {
      breadcrumps.push({
        '@type': 'ListItem',
        position: slugParentSplit.length > maxLength ? 3 : 2,
        name: title,
        item: `${siteUrl}${uri}`,
      });
    }
  }
  return {
    '@id': `${siteUrl}${uri}#breadcrumb`,
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumps,
  };
};
